import { ApiClientFactory } from "common/middleware/api.client-factory";

export const deleteUserNotifications = async (
  notificationIds: string[],
) => {
  const client = await ApiClientFactory.getUserNotificationsClient();
  await Promise.allSettled(notificationIds.map(id => client.deleteNotification(id)));
}
